"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkQualityDropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../../context/room_session");
const rxjs_1 = require("../../../../hooks/rxjs");
const analytics_1 = require("@streem/analytics");
const networkLevelMessageMap = {
    2: 'Customer Has Below Average Connection',
    1: 'Customer Has a Bad Connection',
    0: 'Customer Lost Connection',
};
const NetworkQualityDropdown = ({ showNetworkQuality, }) => {
    const theme = (0, ui_react_1.useTheme)();
    const roomSession = (0, room_session_1.useRoomSession)();
    const [remoteNetworkQuality] = (0, rxjs_1.useObservable)(roomSession.media.remoteNetworkQuality);
    const [isBadRemoteNetworkQuality, setIsBadRemoteNetworkQuality] = (0, react_1.useState)(false);
    const [enableDropdown, setEnableDropdown] = (0, react_1.useState)(false);
    const [showDropdown, setShowDropdown] = (0, react_1.useState)(false);
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const [networkLevelMessage, setNetworkLevelMessage] = (0, react_1.useState)('');
    const dropdownEllipsisRef = (0, react_1.useRef)(null);
    const dropdownTooltipId = 'network-quality-dropdown-tooltip';
    const iconButtonId = 'network-quality-dropdown-button';
    (0, react_1.useEffect)(() => {
        var _a;
        if (!showNetworkQuality ||
            remoteNetworkQuality === null ||
            remoteNetworkQuality === undefined)
            return;
        if (remoteNetworkQuality < 3) {
            setEnableDropdown(true);
            setIsBadRemoteNetworkQuality(remoteNetworkQuality < 2);
            setNetworkLevelMessage((_a = networkLevelMessageMap[remoteNetworkQuality]) !== null && _a !== void 0 ? _a : '');
        }
        else {
            setEnableDropdown(false);
            // handle situation where dropdown was previously opened
            setShowDropdown(false);
        }
    }, [remoteNetworkQuality, showNetworkQuality]);
    const handleDropdownClick = (0, react_1.useCallback)(() => {
        setShowDropdown(!showDropdown);
        if (showDropdown) {
            (0, analytics_1.recordElementClicked)(iconButtonId);
        }
        setShowTooltip(false);
    }, [showDropdown]);
    const handleTooltipMouseEnter = (0, react_1.useCallback)(() => {
        setShowTooltip(!showDropdown);
        (0, analytics_1.recordTooltipViewed)(dropdownTooltipId);
    }, [showDropdown]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(NetworkQualityDropdownTooltipContainer, { children: enableDropdown ? ((0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ message: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: theme.colors.black, size: "small" }, { children: "More Information" })), showTooltip: showTooltip, placement: "bottom", fallbackPlacements: ['bottom'], dataTestId: dropdownTooltipId }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: dropdownEllipsisRef }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { iconName: "VerticalEllipsesIcon", label: "Network Quality Dropdown", "data-testid": iconButtonId, onClick: handleDropdownClick, fill: theme.colors.azure, hoverFill: theme.colors.azure, onMouseEnter: handleTooltipMouseEnter, onMouseLeave: () => setShowTooltip(false) }) })) }))) : ((0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { iconName: "VerticalEllipsesIcon", label: "Network Quality Dropdown", "data-testid": iconButtonId, fill: theme.colors.grey30, style: { cursor: 'not-allowed' } })) }), enableDropdown && showDropdown && ((0, jsx_runtime_1.jsx)(ui_react_1.Sensor, Object.assign({ onClickOutside: event => {
                    var _a;
                    if ((event === null || event === void 0 ? void 0 : event.target) instanceof Element &&
                        ((_a = dropdownEllipsisRef === null || dropdownEllipsisRef === void 0 ? void 0 : dropdownEllipsisRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)))
                        return;
                    setShowDropdown(false);
                }, onEscape: () => setShowDropdown(false) }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, { message: (0, jsx_runtime_1.jsxs)(DropdownContainer, { children: [(0, jsx_runtime_1.jsx)(ErrorTextContainer, Object.assign({ isBadRemoteNetworkQuality: isBadRemoteNetworkQuality }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ style: {
                                        color: isBadRemoteNetworkQuality
                                            ? theme.colors.red60
                                            : theme.colors.orange60,
                                    } }, { children: networkLevelMessage })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ style: {
                                    marginTop: '24px',
                                    marginBottom: '24px',
                                    paddingLeft: '16px',
                                } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ headingFontFamily: true, as: "h5", style: { fontSize: '18px' } }, { children: "Recommendation for Customer" })) })), (0, jsx_runtime_1.jsx)(Recommendation, { text: "Try switching network types (Wi-Fi/Cellular)", iconName: "WifiRouterIcon" }), (0, jsx_runtime_1.jsx)(Recommendation, { text: "Close other apps on their device", iconName: "TouchPhoneIcon" })] }), showTooltip: showDropdown, arrowSize: "0px", distance: 20, offsetValue: -196, placement: "bottom", fallbackPlacements: ['bottom'], dataTestId: "network-quality-dropdown", padding: "0px" }) })))] }));
};
exports.NetworkQualityDropdown = NetworkQualityDropdown;
const Recommendation = ({ text, iconName }) => {
    return ((0, jsx_runtime_1.jsxs)(ui_react_1.Row, Object.assign({ marginRight: '12px', marginBottom: '16px' }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ width: "50px", justifyContent: 'center' }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: iconName }) })), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, { children: text })] })));
};
const NetworkQualityDropdownTooltipContainer = (0, ui_react_1.styled)(ui_react_1.Flex)(() => ({
    marginInlineStart: 'auto',
}));
const DropdownContainer = (0, ui_react_1.styled)(ui_react_1.Column)();
const ErrorTextContainer = (0, ui_react_1.styled)(ui_react_1.Row)(({ theme, isBadRemoteNetworkQuality }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    background: isBadRemoteNetworkQuality ? theme.colors.errorPink : theme.colors.orange05,
    height: '45px',
}));
//# sourceMappingURL=network_quality_dropdown_menu.js.map